export const OptionalNumber = <T extends string | null | undefined>(value: T): Exclude<T, string> | number => {
  if (typeof value !== 'string') return value as Exclude<T, string>
  return Number(value)
}

export const OptionalString = <T extends number | null | undefined>(value: T): Exclude<T, number> | string => {
  if (typeof value !== 'number') return value as Exclude<T, number>
  return String(value)
}
